/**
 * Aceita apenas caminhos internos ("/usuarios"), nunca URLs absolutas ou
 * "//host" — evita open redirect via ?redirect=.
 */
export function safeRedirect(target: string | undefined): string {
  return target && target.startsWith('/') && !target.startsWith('//') ? target : '/'
}
